export default [
  {
    path: '/admin/opinion',
    name: 'opinion',
    component: () => import('@/views/menu/public/opinion.vue'),
    meta: {
      pageTitle: 'مدیریت نظرهای مشتریان',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
  {
    path: '/admin/opinion/details',
    name: 'addopinion',
    component: () => import('@/views/menu/public/opiniondetails.vue'),
    meta: {
      pageTitle: 'ایجاد نظر',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
  {
    path: '/admin/opinion/details/:id',
    name: 'updateopinion',
    component: () => import('@/views/menu/public/opiniondetails.vue'),
    meta: {
      pageTitle: 'ویرایش نظر',
      action: 'show',
      resource: 'OpinionManager',
    },
  },
]
